import React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

const PoliticaConflictoIntereses = () => (
  <Layout>
    <Seo title="Política de conflicto de intereses" />

    <div className="page-legal container">
      <h1 className="title">Política de conflicto de intereses</h1>

      <p className="legal-subtitle">
        Reglas sobre gestión de conflictos de interés
      </p>

      <p>
        La correduría BROKALIA DIVERSOS, CORREDURIA DE SEGUROS, S.L. tiene aprobado un protocolo con el fin de gestionar y resolver los eventuales conflictos de interés que pudieran surgir dentro de la organización por razón de su actividad.
      </p>

      <p>
        <strong>Conflictos de intereses:</strong>
      </p>

      <ul>
        <li>
          Se considera que existe un conflicto de intereses cuando algún miembro de la correduría con poder de decisión pudiera ver afectada la imparcialidad y objetividad de su actuación debido a la influencia y el peso de sus propios intereses personales o de intereses de terceros que el miembro administra, vigila o custodia.</li>

        <li>En particular se tiene por objetivo evitar y resolver potenciales conflictos de intereses, entendiendo así los que entrañen un riesgo de lesión de los intereses de un cliente real o potencial con respecto a los de:
          <ul>
            <li>las compañías aseguradoras que ofertan los productos que distribuye la correduría o el personal de las mismas, o</li>
            <li>la propia correduría, o</li>
            <li>cualquier persona ligada directa o indirectamente a los anteriores por vínculos de control, o</li>
            <li>cualquier cliente, real o potencial, con el que la empresa mantenga vínculos contractuales.</li>
          </ul>

        </li>
      </ul>

      <p>
        <strong>Contenido del protocolo aprobado</strong>
      </p>

      <p>
        El protocolo establece las normas y procedimientos para manejar dichos conflictos:
      </p>

      <ul>
        <li>Se determina a qué personas alcanza la aplicación de dichas normas: todo el personal administrativo y técnico para desarrollar de nuestra actividad, con independencia del tipo de vínculo jurídico (laboral, civil, mercantil, etc.) existente entre el personal y la correduría. Igualmente, las reglas resultan aplicables a los integrantes de los órganos de administración y dirección de la correduría.</li>
        <li>Se nombra a la persona responsable de supervisar el cumplimiento de las reglas y tomar medidas para prevenir y gestionar los conflictos dentro de la organización de la correduría.</li>
        <li>Se identifica de forma abstracta los potenciales conflictos de intereses: Se detallan ejemplos de situaciones que podrían generar conflictos de interés y se establecen medidas para evitarlos y resolverlos.</li>
        <li>Se establecen los cauces para que ciertos miembros de la correduría declaren potenciales conflictos de interés anualmente y los actualicen si es necesario.</li>
        <li>Se establecen restricciones sobre la aceptación de regalos o favores que puedan influir en la imparcialidad de los miembros de la correduría.</li>
        <li>Se establecen principios para actuar de manera imparcial y proteger los intereses de los clientes en caso de conflictos de interés, haciendo especial referencia a las medidas adicionales relacionadas con la distribución de productos de inversión basados en seguros.</li>
        <li>Se establecen consecuencias para el incumplimiento de las normas sobre conflictos de interés.</li>
        <li>Se establece la aprobación del documento, su entrada en vigor y la realización de revisiones anuales para garantizar su actualización y eficacia.</li>
      </ul>

      <p className="nota">
        NOTA: Puede solicitar el documento completo que contiene las normas sobre la gestión de conflictos de interés de la correduría dirigiendo su petición a <a href="mailto:compliance@brokalia.com">compliance@brokalia.com</a>.
      </p>
    </div>
  </Layout>
)

export default PoliticaConflictoIntereses
